"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//: фильтрация светильников на сайте
const proxy_1 = require("../helps/proxy");
const panels_1 = require("../../../ajax/panels");
const create_1 = __importDefault(require("./create"));
const data_start_1 = require("../../data-start");
//= filterLamps
const filterLamps = (currentArrLamps) => {
    try {
        const formFilter = document.querySelector('#form-filter');
        const buttonResetFilter = document.querySelector('#button-reset-filter');
        buttonResetFilter.addEventListener('click', () => {
            formFilter.reset();
            (0, create_1.default)(currentArrLamps);
        });
        formFilter.addEventListener('input', () => {
            const checkboxAll = document.querySelectorAll('.filter-checkbox__input');
            //* массив уникальных ключей по которым фильтруем светильники
            let arrKey = [];
            //* получение всех уникальных ключей
            checkboxAll.forEach(item => {
                const name = item.name;
                console.log(name);
                const isMatchKey = arrKey.includes(name);
                if (item.checked && !isMatchKey) {
                    arrKey.push(name);
                }
            });
            //* обьект для дальнейшей фильтрации типа {key: [value], key: [value]}
            let objectFilter = {};
            //* создание обьекта с ключами в которыз значения пустые массивы для дальнейшего заполнения значениями
            arrKey.forEach(key => {
                objectFilter[key] = [];
            });
            //* заполнение ключей значениями
            checkboxAll.forEach(item => {
                if (item.checked && (0, panels_1.isLedKey)(item.name)) {
                    const name = item.name;
                    objectFilter[name].push(item.value);
                }
            });
            //* фильтрация по всем checkbox
            const resalt = currentArrLamps.filter(lamp => {
                const length = Object.keys(objectFilter).length;
                let totalMatch = 0;
                for (let key in objectFilter) {
                    if ((0, panels_1.isLedKey)(key)) {
                        let isMatch = false;
                        //*-1 проверка, поподает ли значение из поля wats в промежуток 
                        if (key === 'wats-segment') {
                            const from = +objectFilter[key][0].split('-')[0];
                            const to = +objectFilter[key][0].split('-')[1];
                            const str = lamp.wats;
                            // wats - значение сколько ват у данного обьекта lamp, получаем с поля lamp.wats
                            const wats = typeof str !== 'undefined' ? parseInt(str) : undefined;
                            if (wats !== undefined && from < wats && wats < to) {
                                isMatch = true;
                            }
                            else {
                                isMatch = false;
                            }
                            //*-1 end
                        }
                        else {
                            isMatch = objectFilter[key].includes(lamp[key]);
                        }
                        if (isMatch) {
                            totalMatch++;
                        }
                    }
                }
                if (totalMatch === length) {
                    return lamp;
                }
            });
            //* фильтрация по цене
            const form = document.querySelector('#form-filter');
            const from = +form.from.value;
            const until = +form.until.value === 0 ? Infinity : +form.until.value;
            // from / until числа от и до 
            //* resaltPrice - массив с отфильтрованными обьектами по цене и по checkbox
            const resaltPrice = resalt.filter(lamp => {
                if (lamp.price && from <= +lamp.price * data_start_1.priceUP && +lamp.price * data_start_1.priceUP <= until) {
                    return lamp;
                }
            });
            proxy_1.proxy.lamps = resaltPrice;
            return resaltPrice;
        });
    }
    catch (error) {
        console.log(error);
    }
};
exports.default = filterLamps;
